const getFloatingValue = (value) => {
    if (value === undefined || value === null || isNaN(value) || value === "" || value === 0 || value === "0" || Number(value) == 0) {
        return "0.000";
    } else {
        return Number(value || 0).toFixed(3);
    }
};

const formatedDate = (dateStr) => {
    if (!dateStr) return "-";
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    return d.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
    });
};

const areYouSureFn = (swal, callbackFn, message = "Are you sure?") => {
    swal.fire({
        title: message,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
    }).then((result) => {
        if (result.isConfirmed) {
            callbackFn();
        }
    });
};

export { getFloatingValue, formatedDate, areYouSureFn };